import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import PageInfoModal from "../../Components/PageInfoModal/PageInfoModal";

const SORGU_INFO_ITEMS = [
  { icon: 'patch-question-fill', text: 'Bu səhifədə sistem qaydaları barədə bilik yoxlaması (sorğu) keçirə bilərsiniz.' },
  { icon: 'book-half', text: 'Sorğuya başlamadan əvvəl drive-da göndərilmiş bütün təlimatları oxuduğunuzdan əmin olun.' },
  { icon: 'play-fill', text: '"Sorğuya başla" düyməsi ilə 3 sualdan ibarət testi başlada bilərsiniz.' },
  { icon: 'trophy', text: 'Bütün sualları düzgün cavablamaq (100%) şərti ilə sorğunu tamamlamış sayılırsınız.' },
  { icon: 'arrow-clockwise', text: 'Sorğu tamamlanmamışsa, istənilən vaxt yenidən cəhd edə bilərsiniz.' },
];

const QUESTIONS = [
  {
    id: 1,
    text: "Sistem qaydalarına görə müəllim dərsdən neçə dəqiqə əvvəl sistemə daxil olmalıdır?",
    options: ["5 dəqiqə", "10 dəqiqə", "15 dəqiqə", "30 dəqiqə"],
    correct: 1,
  },
  {
    id: 2,
    text: "Davamiyyət hansı müddət ərzində göndərilməlidir?",
    options: ["Dərsdən əvvəl", "Dərs zamanı", "Dərsdən 30 dəqiqə sonra", "Sabahı günə qədər"],
    correct: 2,
  },
  {
    id: 3,
    text: "Müəllim qeydi hansı dildə yazılmalıdır?",
    options: ["İngilis dilində", "Rus dilində", "Azərbaycan dilində", "İstənilən dildə"],
    correct: 2,
  },
];

export default function SorguPage() {
  const [completed, setCompleted] = useState(
    () => localStorage.getItem("sorgu_completed") === "true"
  );
  const [showQuiz, setShowQuiz] = useState(false);
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const allAnswered = QUESTIONS.every((q) => answers[q.id] !== undefined);
  const allCorrect = QUESTIONS.every((q) => answers[q.id] === q.correct);
  const correctCount = submitted ? QUESTIONS.filter((q) => answers[q.id] === q.correct).length : 0;

  const handleStart = () => {
    setAnswers({});
    setSubmitted(false);
    setShowQuiz(true);
  };

  const handleSubmit = () => {
    setSubmitted(true);
    if (allCorrect) {
      localStorage.setItem("sorgu_completed", "true");
      setCompleted(true);
    }
  };

  const handleClose = () => {
    setShowQuiz(false);
    setSubmitted(false);
    setAnswers({});
  };

  return (
    <div style={{ maxWidth: 680, margin: "0 auto", padding: "32px 16px" }}>

      {/* Hero kartı */}
      <div style={{
        borderRadius: 20,
        overflow: "hidden",
        boxShadow: "var(--shadow-sm)",
        marginBottom: 20,
      }}>
        {/* Üst şerit */}
        <div style={{
          background: "var(--color-primary)",
          padding: "28px 32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <PageInfoModal title="Sorğu" items={SORGU_INFO_ITEMS} light />
            <div style={{
              width: 52, height: 52, borderRadius: 14,
              background: "#1d4ed8",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
            }}>
              <i className="bi bi-patch-question-fill" style={{ fontSize: 26, color: "#fff" }}></i>
            </div>
            <div>
              <h4 style={{ margin: 0, fontWeight: 800, fontSize: 20, color: "#fff" }}>Sistem Sorğusu</h4>
              <p style={{ margin: 0, fontSize: 12, color: "#dbeafe", marginTop: 3 }}>
                3 sualdan ibarət bilik yoxlaması
              </p>
            </div>
          </div>

          {/* Status badge */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
          <div style={{
            background: completed ? "#d1fae5" : "#fee2e2",
            border: `1.5px solid ${completed ? "#6ee7b7" : "#fca5a5"}`,
            borderRadius: 40,
            padding: "6px 16px 6px 8px",
            display: "flex", alignItems: "center", gap: 8, flexShrink: 0,
          }}>
            <span style={{
              width: 26, height: 26, borderRadius: "50%",
              background: completed ? "#059669" : "#ef4444",
              color: "#fff", fontSize: 13, fontWeight: 800,
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: `0 2px 8px ${completed ? "rgba(5,150,105,0.4)" : "rgba(239,68,68,0.4)"}`,
            }}>
              {completed ? "0" : "1"}
            </span>
            <span style={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>
              {completed ? "Tamamlandı" : "Gözləyir"}
            </span>
          </div>
          </div>
        </div>

        {/* Alt hissə */}
        <div style={{ background: "#fff", padding: "24px 32px" }}>
          {/* Xəbərdarlıq */}
          <div style={{
            background: "#fffbeb",
            border: "1px solid #fde68a",
            borderRadius: 10,
            padding: "12px 16px",
            display: "flex", gap: 10, alignItems: "flex-start",
            marginBottom: 24,
          }}>
            <i className="bi bi-exclamation-triangle-fill" style={{ color: "#f59e0b", fontSize: 15, flexShrink: 0, marginTop: 1 }}></i>
            <p style={{ margin: 0, fontSize: 13, color: "#78350f", lineHeight: 1.6 }}>
              Bu sorğuda iştirak etməzdən əvvəl <strong>sistem tərəfindən göndərilən və
              driveda olan bütün təlimatları oxuduğunuzdan əmin olun.</strong>
            </p>
          </div>

          {/* İnfo sətirləri */}
          <div style={{ display: "flex", gap: 12, marginBottom: 28 }}>
            {[
              { icon: "bi-list-ol", label: "Sual sayı", value: "3" },
              { icon: "bi-clock", label: "Müddət", value: "Limitsiz" },
              { icon: "bi-trophy", label: "Keçid", value: "100%" },
            ].map((item) => (
              <div key={item.label} style={{
                flex: 1, background: "#f9fafb", borderRadius: 10,
                padding: "12px 14px", border: "1px solid #f3f4f6",
                display: "flex", flexDirection: "column", gap: 4,
              }}>
                <i className={`bi ${item.icon}`} style={{ fontSize: 16, color: "var(--color-primary)" }}></i>
                <span style={{ fontSize: 11, color: "#9ca3af", fontWeight: 500 }}>{item.label}</span>
                <span style={{ fontSize: 13, color: "#111827", fontWeight: 700 }}>{item.value}</span>
              </div>
            ))}
          </div>

          {/* Düymə */}
          {!completed && (
            <button
              onClick={handleStart}
              style={{
                width: "100%", padding: "13px",
                background: "var(--color-primary)",
                border: "none", color: "#fff",
                borderRadius: 12, fontSize: 15, fontWeight: 700,
                cursor: "pointer", letterSpacing: "0.02em",
                boxShadow: "var(--shadow-md)",
              }}
            >
              <i className="bi bi-play-fill me-2"></i>Sorğuya başla
            </button>
          )}
        </div>
      </div>

      {/* Quiz Modal */}
      <Modal show={showQuiz} onHide={handleClose} centered size="lg" backdrop="static" dialogClassName="sorgu-quiz-modal" scrollable>
        <div style={{ borderRadius: 20, overflow: "hidden", boxShadow: "0 24px 64px rgba(101,40,206,0.22)", display: "flex", flexDirection: "column", height: "80vh", maxHeight: 680 }}>

          {/* Header */}
          <div style={{
            background: "linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-dark) 100%)",
            padding: "24px 32px",
            display: "flex", alignItems: "center", justifyContent: "space-between",
            position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", top: -30, right: 120, width: 120, height: 120, borderRadius: "50%", background: "#1d4ed8", pointerEvents: "none" }} />
            <div style={{ position: "absolute", bottom: -20, right: 40, width: 80, height: 80, borderRadius: "50%", background: "#2563eb", pointerEvents: "none" }} />
            <div style={{ display: "flex", alignItems: "center", gap: 14, position: "relative" }}>
              <div style={{
                width: 46, height: 46, borderRadius: 12,
                background: "#1d4ed8",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
              }}>
                <i className="bi bi-patch-question-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              </div>
              <div>
                <div style={{ fontWeight: 800, fontSize: 17, color: "#fff", letterSpacing: "-0.2px" }}>
                  Sistem Qaydaları — Bilik Yoxlaması
                </div>
                <div style={{ fontSize: 12, color: "#dbeafe", marginTop: 3 }}>
                  {Object.keys(answers).length} / {QUESTIONS.length} sual cavablandı
                </div>
              </div>
            </div>
            <button
              onClick={handleClose}
              style={{
                background: "#dbeafe", border: "1px solid #bfdbfe",
                borderRadius: 10, width: 34, height: 34, color: "#1d4ed8", cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18,
                position: "relative", flexShrink: 0,
              }}
            >×</button>
          </div>

          {/* Progress bar */}
          <div style={{ background: "#dbeafe", height: 5 }}>
            <div style={{
              height: "100%",
              width: `${(Object.keys(answers).length / QUESTIONS.length) * 100}%`,
                background: "linear-gradient(90deg, var(--color-primary), #60a5fa)",
              transition: "width 0.35s cubic-bezier(.4,0,.2,1)",
              borderRadius: "0 3px 3px 0",
            }} />
          </div>

          {/* Body */}
          <div style={{ background: "#fafafa", padding: "28px 32px 16px", overflowY: "auto", flex: 1, minHeight: 0 }}>

            {/* Nəticə banneri */}
            {submitted && (
              <div style={{
                background: allCorrect
                  ? "linear-gradient(135deg, #ecfdf5, #d1fae5)"
                  : "linear-gradient(135deg, #fef2f2, #fee2e2)",
                border: `1.5px solid ${allCorrect ? "#059669" : "#ef4444"}`,
                borderRadius: 14, padding: "16px 20px", marginBottom: 24,
                display: "flex", alignItems: "center", gap: 14,
              }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 12, flexShrink: 0,
                  background: allCorrect ? "#059669" : "#ef4444",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  boxShadow: `0 4px 14px ${allCorrect ? "rgba(5,150,105,0.35)" : "rgba(239,68,68,0.35)"}`,
                }}>
                  <i className={`bi bi-${allCorrect ? "check-lg" : "x-lg"}`} style={{ color: "#fff", fontSize: 22 }}></i>
                </div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 15, color: allCorrect ? "#065f46" : "#991b1b" }}>
                    {allCorrect ? "Əla nəticə! Bütün sualları düzgün cavabladınız." : "Bəzi cavablar səhvdir."}
                  </div>
                  <div style={{ fontSize: 13, color: "#6b7280", marginTop: 4 }}>
                    Düzgün cavab: <strong style={{ color: allCorrect ? "#059669" : "#ef4444" }}>{correctCount}</strong> / {QUESTIONS.length}
                  </div>
                </div>
              </div>
            )}

            {/* Suallar */}
            {QUESTIONS.map((q, qi) => {
              const chosen = answers[q.id];
              const isAnswered = chosen !== undefined;
              return (
                <div key={q.id} style={{
                  background: "#fff",
                  border: `1.5px solid ${isAnswered && !submitted ? "#93c5fd" : "#e5e7eb"}`,
                  borderRadius: 16, padding: "20px 24px",
                  marginBottom: qi < QUESTIONS.length - 1 ? 16 : 0,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                  transition: "border-color 0.2s",
                }}>
                  {/* Sual başlığı */}
                  <div style={{ display: "flex", gap: 12, marginBottom: 16, alignItems: "flex-start" }}>
                    <span style={{
                      width: 30, height: 30, borderRadius: 8, flexShrink: 0,
                      background: "linear-gradient(135deg, var(--color-primary), #60a5fa)",
                      color: "#fff", fontSize: 13, fontWeight: 800,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(37,99,235,0.35)",
                    }}>{qi + 1}</span>
                    <p style={{ margin: 0, fontSize: 14, fontWeight: 700, color: "#111827", lineHeight: 1.65 }}>
                      {q.text}
                    </p>
                  </div>

                  {/* Variantlar — 2 sütun */}
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    {q.options.map((opt, oi) => {
                      const isSelected = chosen === oi;
                      const isCorrect = submitted && oi === q.correct;
                      const isWrong = submitted && isSelected && oi !== q.correct;
                      const borderColor = isCorrect ? "#059669" : isWrong ? "#ef4444" : isSelected ? "var(--color-primary)" : "#e5e7eb";
                      const bgColor = isCorrect ? "#dcfce7" : isWrong ? "#fee2e2" : isSelected ? "#dbeafe" : "#fafafa";
                      const textColor = isCorrect ? "#065f46" : isWrong ? "#991b1b" : isSelected ? "var(--color-primary-dark)" : "#374151";

                      return (
                        <button
                          key={oi}
                          onClick={() => !submitted && setAnswers(prev => ({ ...prev, [q.id]: oi }))}
                          style={{
                            display: "flex", alignItems: "center", gap: 12,
                            padding: "12px 16px", borderRadius: 12,
                            cursor: submitted ? "default" : "pointer",
                            border: `1.5px solid ${borderColor}`,
                            background: bgColor,
                            textAlign: "left", fontSize: 13, fontWeight: isSelected || isCorrect ? 700 : 500,
                            color: textColor, transition: "all 0.15s",
                            boxShadow: isSelected && !submitted ? "0 2px 8px rgba(37,99,235,0.15)" : "none",
                          }}
                        >
                          <div style={{
                            width: 20, height: 20, borderRadius: "50%", flexShrink: 0,
                            border: `2px solid ${borderColor}`,
                            background: isCorrect ? "#059669" : isWrong ? "#ef4444" : isSelected ? "var(--color-primary)" : "#fff",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            transition: "all 0.15s",
                          }}>
                            {(isSelected || isCorrect) && (
                              <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#fff" }} />
                            )}
                          </div>
                          <span style={{ flex: 1, lineHeight: 1.4 }}>{opt}</span>
                          {isCorrect && <i className="bi bi-check-circle-fill" style={{ color: "#059669", fontSize: 15, flexShrink: 0 }}></i>}
                          {isWrong && <i className="bi bi-x-circle-fill" style={{ color: "#ef4444", fontSize: 15, flexShrink: 0 }}></i>}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div style={{
            background: "#fff", borderTop: "1px solid #f3f4f6",
            padding: "16px 32px", display: "flex", justifyContent: "space-between", alignItems: "center",
          }}>
            <span style={{ fontSize: 12, color: "#9ca3af" }}>
              {submitted
                ? allCorrect ? "Sorğu tamamlandı" : "Sorğu başa çatdı"
                : `${QUESTIONS.length - Object.keys(answers).length} sual qalıb`
              }
            </span>
            <div style={{ display: "flex", gap: 10 }}>
              {!submitted ? (
                <>
                  <button
                    onClick={handleClose}
                    style={{
                      background: "#fff", border: "1.5px solid #e5e7eb", color: "#374151",
                      borderRadius: 10, padding: "10px 22px", fontSize: 13, fontWeight: 600, cursor: "pointer",
                    }}
                  >
                    Bağla
                  </button>
                  <button
                    onClick={handleSubmit}
                    disabled={!allAnswered}
                    style={{
                      background: allAnswered ? "linear-gradient(135deg, var(--color-primary), var(--color-primary-dark))" : "#e5e7eb",
                      border: "none", color: allAnswered ? "#fff" : "#9ca3af",
                      borderRadius: 10, padding: "10px 28px", fontSize: 13, fontWeight: 700,
                      cursor: allAnswered ? "pointer" : "not-allowed",
                      boxShadow: allAnswered ? "0 4px 14px rgba(37,99,235,0.35)" : "none",
                      transition: "all 0.2s",
                    }}
                  >
                    <i className="bi bi-check2-all me-2"></i>Təsdiqlə
                  </button>
                </>
              ) : (
                <button
                  onClick={handleClose}
                  style={{
                    background: allCorrect
                      ? "linear-gradient(135deg, #059669, #047857)"
                      : "linear-gradient(135deg, #ef4444, #b91c1c)",
                    border: "none", color: "#fff", borderRadius: 10, padding: "10px 28px",
                    fontSize: 13, fontWeight: 700, cursor: "pointer",
                    boxShadow: allCorrect ? "0 4px 14px rgba(5,150,105,0.35)" : "0 4px 14px rgba(239,68,68,0.35)",
                  }}
                >
                  <i className={`bi bi-${allCorrect ? "check-circle-fill" : "x-circle-fill"} me-2`}></i>Bağla
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <style>{`
        .sorgu-quiz-modal .modal-dialog {
          max-width: 760px !important;
        }
        .sorgu-quiz-modal .modal-content {
          border: none !important;
          border-radius: 20px !important;
          overflow: hidden;
          height: 80vh;
          max-height: 680px;
          display: flex;
          flex-direction: column;
          box-shadow: var(--shadow-lg) !important;
        }
        .sorgu-quiz-modal .modal-body {
          padding: 0 !important;
          flex: 1;
          min-height: 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </div>
  );
}
